/** Fetches the embedded (`cid:`) images of a pasted email, keyed by content id. */
import { config } from '../../shared/config/environment';
import { fetchWithRefresh, type RefreshTokenFn } from '../../shared/api/fetchWithRefresh';

export interface EmailInlineImage {
  content_type: string;
  /** Base64 of the image bytes. */
  data: string;
}

export async function fetchEmailInlineImages(
  messageId: string,
  contentIds: string[],
  mailbox: string | null,
  apiToken: string,
  refresh?: RefreshTokenFn
): Promise<Record<string, EmailInlineImage>> {
  const response = await fetchWithRefresh(
    `${config.aiApiBaseUrl}/api/v2/word/email-images`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${apiToken}` },
      body: JSON.stringify({
        message_id: messageId,
        content_ids: contentIds,
        ...(mailbox ? { mailbox } : {}),
      }),
    },
    refresh
  );
  if (!response.ok) throw new Error(`email images request failed (${response.status})`);
  const payload = (await response.json()) as { images?: Record<string, EmailInlineImage> };
  return payload.images ?? {};
}
